var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1694585614708,
    className: "icon",
    viewBox: "0 0 1037 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7189,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.780203 512.006305A243.638379 243.638379 0 1 0 512.418581 268.367927 244.142806 244.142806 0 0 0 268.780203 512.006305z m412.117092 0A167.974286 167.974286 0 1 1 512.418581 344.032019 168.478713 168.478713 0 0 1 680.392867 512.006305z",
    fill: "currentColor",
    "p-id": 7190
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M947.739329 476.696395v7.061982a34.301055 34.301055 0 0 0 40.354182 30.770065 40.85861 40.85861 0 0 0 34.301056-44.389601A511.993695 511.993695 0 1 0 512.418581 1024a514.515831 514.515831 0 0 0 478.197067-329.391017 37.832046 37.832046 0 0 0-70.61982-27.239074 436.329602 436.329602 0 1 1 27.239073-190.673514z",
    fill: "currentColor",
    "p-id": 7191
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.21a5261c6541f56cc931717efd50e8ea.svg";
export { ForwardRef as ReactComponent };